import type { SupabaseClient } from '../client'
import { unwrapList } from './_helpers'

export type SprintRow = {
  id: number
  project_id: number
  initiative_id: number | null
  title: string
  status: 'planning' | 'active' | 'done' | string
  start_date: string | null
  end_date: string | null
  goal: string | null
  created_at: string | null
}

const SPRINT_COLUMNS =
  'id, project_id, initiative_id, title, status, start_date, end_date, goal, created_at'

/**
 * Lista sprints de um projeto. Default: ordenadas por start_date desc.
 * Aceita filtro opcional por initiativeId e por status.
 */
export async function listSprintsByProject(
  client: SupabaseClient,
  projectId: number,
  opts: { initiativeId?: number | null; status?: string | string[] } = {},
): Promise<SprintRow[]> {
  let q = client
    .schema('operacoes')
    .from('sprints')
    .select(SPRINT_COLUMNS)
    .eq('project_id', projectId)
    .order('start_date', { ascending: false, nullsFirst: false })

  if (typeof opts.initiativeId === 'number') q = q.eq('initiative_id', opts.initiativeId)
  if (Array.isArray(opts.status)) q = q.in('status', opts.status)
  else if (opts.status) q = q.eq('status', opts.status)

  return unwrapList(await q) as unknown as SprintRow[]
}
